export enum QueryStatus {
	SUCCESS = 'SUCCESS',
	NOT_FOUND = 'NOT_FOUND',
	ERROR = 'ERROR'
}

// NovaVida devolve tudo como texto (o servidor retorna EnrichmentResult.data
// verbatim). Flags vêm como 'S'/'N' (ou '1'/'0'); use isFlag() para interpretá-las.
export interface CadastraisData {
	CPF: string;
	NOME: string;
	NOME_MAE?: string;
	SEXO?: string;
	NASC?: string;
	IDADE?: string | number;
	RENDA?: string | number;
	SCORE?: string | number;
	SCORE_CREDITO?: string | number;
	SCORE_DIGITAL?: string | number;
	FLAG_FGTS?: string | boolean;
	FLAG_OBITO?: string | boolean;
	[key: string]: any;
}

export interface EnderecoData {
	LOGRADOURO?: string;
	NUMERO?: string;
	COMPLEMENTO?: string;
	BAIRRO?: string;
	CIDADE?: string;
	UF?: string;
	CEP?: string;
	[key: string]: any;
}

export interface TelefoneData {
	DDD?: string;
	TELEFONE?: string;
	OPERADORA?: string;
	FLWHATS?: string | boolean;
	[key: string]: any;
}

export interface EmailData {
	EMAIL?: string;
	POSICAO?: string;
}

// Interpreta flags NovaVida ('S'/'N', '1'/'0', boolean) como booleano.
export function isFlag(value?: string | boolean | number): boolean {
	if (value === undefined || value === null) return false;
	if (typeof value === 'boolean') return value;
	const v = String(value).trim().toUpperCase();
	return v === 'S' || v === '1' || v === 'SIM' || v === 'TRUE';
}

export interface NovaVidaData {
	CADASTRAIS: CadastraisData;
	ENDERECOS: EnderecoData[];
	TELEFONES: TelefoneData[];
	EMAILS: EmailData[];
}

export interface ConsultaResult {
	cpf: string;
	status: QueryStatus;
	fromCache: boolean;
	cost: number;
	queryId?: string;
	data: NovaVidaData | null;
}

// Item do histórico dos últimos 10 leads (7 dias). `available` = dado ainda em
// cache, então a revisualização é gratuita.
export interface HistoryItem {
	cpf: string;
	name: string | null;
	searchedAt: string;
	available: boolean;
}
